/* @flow */
import * as React from 'react';
import { difference, differenceBy, map, reject } from 'lodash/fp';
import { TweenMax } from 'gsap';

const getKeys = map('key');
const differenceByKey = differenceBy('key');

type Props = {
  children: React.ChildrenArray<*>,
  enterAt?: 'bottom' | 'top',
  onRemove: (string) => TweenMax,
  onUpdate: (Array<string>, Array<string>) => void,
};

type State = {
  prevChildren: React.ChildrenArray<*>,
  removalCount: number,
};

class AnimationList extends React.Component<Props, State> {
  props: Props;
  state: State = {
    prevChildren: [],
    removalCount: 0,
  };

  static defaultProps = {
    enterAt: 'bottom',
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { children, onRemove } = this.props;
    const oldKeys = difference(getKeys(children), getKeys(nextProps.children));

    this.setState(state => ({
      prevChildren: children,
      removalCount: state.removalCount + oldKeys.length,
    }));

    oldKeys.forEach((key) => {
      onRemove(key).eventCallback('onComplete', () => {
        this.handleRemove(key);
      });
    });
  }

  componentDidUpdate(prevProps: Props) {
    const { children, onUpdate } = this.props;

    onUpdate(getKeys(children), getKeys(prevProps.children));
  }

  handleRemove = (key: string) => {
    this.setState(state => ({
      prevChildren: reject({ key }, state.prevChildren),
      removalCount: state.removalCount - 1,
    }));
  };

  render() {
    const { children, enterAt } = this.props;
    const { prevChildren, removalCount } = this.state;

    if (removalCount === 0) {
      return children;
    }

    const newChildren = differenceByKey(children, prevChildren);

    return enterAt === 'top' ? [...newChildren, ...prevChildren] : [...prevChildren, ...newChildren];
  }
}

export default AnimationList;
